// buy.js

export const types = {
  READY: 'BUY.READY',
  BUYING: 'BUY.BUYING',
  MAINURLRECEIVED: 'BUY.MAINURLRECEIVED',
  GOTSIZE1: 'BUY.GOTSIZE1',
  GOTSIZE2: 'BUY.GOTSIZE2',
  GOTSIZE3: 'BUY.GOTSIZE3',
  COMPLETE: 'BUY.COMPLETE'
};

export const ready = () => ({
  type: types.READY
});

export const buying = () => ({
  type: types.BUYING
});

export const mainurlreceived = url => ({
  type: types.MAINURLRECEIVED,
  main_url: url
});

export const gotsize1 = url => ({
  type: types.GOTSIZE1,
  thumb_url_1: url
});

export const gotsize2 = url => ({
  type: types.GOTSIZE2,
  thumb_url_2: url
});

export const gotsize3 = url => ({
  type: types.GOTSIZE3,
  thumb_url_3: url
});

export const complete = () => ({
  type: types.COMPLETE
});



// WEBPACK FOOTER //
// ./src/store/actions/buy.js